import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core'
import { registerLocaleData } from '@angular/common'
import { provideHttpClient } from '@angular/common/http'
import localeEs from '@angular/common/locales/es'
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router'
import { SETTINGS, SPANISH_ERROR_MESSAGES, VALIDATION_ERROR_MESSAGES } from 'superlikers-dynamic-forms'
import { provideMicrositesApi } from '@superlikers/microsites-api'

import { settings } from '@shared/utils'
import { environment } from '@environments/environment'
import { routes } from './app.routes'

registerLocaleData(localeEs)

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    // Enlaza params y query params a los `input()` de los componentes de ruta.
    // Cada navegación arranca arriba: sin esto se conserva el scroll de la página anterior.
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),

    provideHttpClient(),

    // Dominio de la campaña: todos los servicios de la librería construyen sus
    // URLs sobre él, y es lo único que cambia entre entornos. La librería pone
    // las cabeceras y manda la cookie de sesión en cada petición.
    provideMicrositesApi({ baseUrl: environment.baseUrl }),

    // Mensajes de validación en español para los formularios dinámicos.
    { provide: VALIDATION_ERROR_MESSAGES, useFactory: () => SPANISH_ERROR_MESSAGES },

    // Apariencia de los controles dinámicos; vive en `shared/utils`.
    { provide: SETTINGS, useValue: settings },

    { provide: LOCALE_ID, useValue: 'es' }
  ]
}
